<template>
    <div>
        <!--业务管理-->
      <!-- <public-title :showBack='isGroup'>业务管理</public-title> -->
        <!--搜索-->
        <div class="load-area businesslist">
            <search-con class="mop-none" :orderType="3" @getSearchCon="getSearchCon" :PersonnelList="PersonnelList"/>
            <el-table
            v-tabelMove
            border
            :row-style="setRowClassName"
             height="850"
            :data="BusinessList"
            @sort-change="sortChange"
            style="width: 100%">
            <el-table-column :prop="item.value" :width="item.width"   :label="item.name" v-for="(item,index) in titleArr" align="center" :sortable="item.name=='入住时间'?'custom':false" :fixed="item.fixed?item.fixed:false">
                <!-- <el-table-column  prop="province" :label="you.name" :width="item.width"  align="center"   v-for="you in layout"   v-if="item.name === '预订房型'">
                        <template slot-scope="scope" >
                            <div  v-for="square in scope.row.type" key="id" v-if="square.id==you.id&&square.room_num!=0" class="square">
                                <span>{{square.room_num}}</span>
                            </div>
                        </template>
                </el-table-column> -->
                <template slot-scope="scope" >
                    <!--普通显示-->
                    <div v-if="!$GFUN.isInArray(['核房人','支付人','预订房型'],item.name)&&!item.first"><span>{{scope.row[item.value]}}</span></div>
                    <!--需求显示-->
                    <div v-if="item.name == '核房人'">
                        <span v-for="(item,index) in  scope.row.verify_arr" :key="item.guide_id" class="verify" v-if="index<1">
                            <span class="verify_arrFlag">{{item.flag==1?'导游：':'领队：'}}{{item.title}}</span>
                            <span class="verify_arrTitle">{{item.mob}}</span>
                        </span>
                    </div>
                    <div v-if="item.name == '支付人'">
                        <span v-for="(item,index) in scope.row.pay_arr" :key="item.guide_id" class="verify" v-if="index<1">
                            <span class="verify_arrFlag">{{item.flag | formatVar('PayerPeople')}}：{{item.title}}</span>
                            <span class="verify_arrTitle">{{item.mob}}</span>
                        </span>
                    </div>
                    <div v-if="item.first&&scope.row[item.value]!=''">
                        {{scope.row[item.value]| formatMoney}}
                    </div>
                    <div v-if="item.name == '预订房型'">
                        <div class="busninessList" >
                            <ul v-for="(item,index) in  scope.row.room_need_arr" :key="index" v-if="index<1">
                                <li v-for="(name,ins) in item.offer_info" :key="name.id" v-if="ins<3">
                                    <span class="timeslot">{{name.offer_title}}</span>
                                    <span>{{name.room_num}}间</span>
                                    <span class="red">¥{{name.offer_price}}</span>
                                </li>
                                <li  v-if="item.room_num!=0&&index<3&&!item.offer_info">
                                    <span class="timeslot">{{item.type | formatVar('roomStyle')}}</span>
                                    <span >{{item.room_num}}间</span>
                                    <span class=" nst red" >{{item.offer_price?'¥'+item.offer_price:''}}</span>
                                </li>
                            </ul>
                            <!-- <span  class="liesq liet" v-if=" scope.row.room_need_arr.length>3">...</span> -->
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="团队状态"
                 fixed="right"
                :width="100">
                <template slot-scope="scope">
                    <div :class="activechange(scope.row.statusName)">
                        {{ scope.row.statusName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                fixed="right"
                label="操作"
                :width="130">
                <template slot-scope="scope"   class="button">
                    <el-dropdown @command="handleCommand($event,scope.$index)">
                        <span class="el-dropdown-link text-link">查看<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  command="1" >查看详情</el-dropdown-item>
                            <el-dropdown-item  command="2" >编辑信息</el-dropdown-item>
                            <el-dropdown-item  command="3" v-if="$GFUN.isInArray([0,9],scope.row.pay_flag_travel)&&scope.row.price_pay>scope.row.price">申请提现</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <div class="scope_button">
                        <el-button  size="mini"   @click="goHotelDetail(scope.$index)">详情</el-button>
                        <el-button  size="mini"  @click="handleEdit(scope.$index)">编辑</el-button>
                        <el-button  size="mini" type="success" @click="withdrawal(scope.$index)" v-if="$GFUN.isInArray([0,9],scope.row.pay_flag_travel)&&scope.row.price_pay>scope.row.price">提现</el-button>
                        <span class="tabarr" v-for="item in tabArr" :class="item.value" v-if="scope.row.pay_flag_travel==item.id">{{item.label}}</span>
                    </div> -->
                    <span class="tabarr" v-for="item in tabArr" :class="item.value" v-if="scope.row.pay_flag_travel==item.id">{{item.label}}</span>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" class="mt-4"  :page-size="30"
            :total="total" :current-page="Number(page)"
            @current-change="v => PsotBusinessList(v)"/>
        </div>
        <!--编辑弹窗-->
        <el-dialog title="编辑信息" :visible.sync="showEdit" center width="500px" top="16%" v-if="showEdit">
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="订单ID" :width="80"/><span v-html="Editindex.oid"></span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="团号/标签" :width="80" /><span v-html="Editindex.title"></span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="入住时间" :width="80"/><span v-html="Editindex.check_date"></span>
            </div>
            <el-form :model="ruleForm"  ref="ruleForm" label-width="90px" class="demo-ruleForm" label-position="left" size="small" >
                <el-form-item label="备注信息" class="lie">
                    <el-input type="text" v-model="ruleForm.travel_flag_content"  maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <div class="background">
                    <div class="teilte">背景颜色</div>
                    <div class="background_select">
                        <!-- <div class="yas" :style=" 'background-color:'+color"></div> -->
                         <el-color-picker
                            v-model="ruleForm.bg_color"
                            color-format="hex"
                            :predefine="predefineColors">
                        </el-color-picker>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="mt-2">
                <el-button @click="showEdit = false;ruleForm.bg_color=''">取 消</el-button>
                <el-button  type="primary" @click="editItem">确 定</el-button>
            </div>
        </el-dialog>
      </div>
</template>
<script>
var dayjs = require('dayjs')
    import { mapState,mapGetters,mapActions } from 'vuex'
    import SearchCon from './SearchCon.vue'
    import { toUpper } from 'lodash';
    export default {
  name: "BusinessList",
  data() {
    return {
            color: '#fff',
            BusinessList: [],
            Editindex:{},                           //点击编辑的值
            PersonnelList:[],                       //人员列表
            showEdit:false,
            color: 'rgba(255, 255, 255, 255)',
                predefineColors: [
                '#eeeeee',
                '#f5f5f5',
                '#595959',
                '#adb9ca',
                '#bdd7ee',
                '#f8cbad',
                '#c9c9c9',
                '#ffe699',
                '#b4c7e7',
                '#c5e0b4',
                '#a6a6a6',
                '#262626',
                '#3b3838',
                '#333f50',
                '#2e75b6',
                '#c55a11',
                '#7c7c7c',
                '#bf9000',
                '#2f5597',
                '#548235',
                '#c00000',
                '#ff0000',
                '#ffc000',
                '#ffff00',
                '#92d050',
                '#00b050',
                '#00b0f0',
                '#0070c0',
                '#002060',
                '#7030a0',
                ],
            titleArr:[
                {name:'入住时间',value:'check_date',width:140},{name:'星期',value:'weekNum',width:60},{name:'天数',value:'days',width:60},{name:'订单号',value:'oid',width:120},{name:'团号/标签',value:'title',width:140},{name:'预订人',value:'send_name',width:60},{name:'人数',value:'num',width:60},{name:'预订房型',value:'room_need_arr',width:220},{name:'核房人',value:'',width:100},{name:'支付人',value:'',width:100},{name:'酒店名称',value:'hotel_title',width:200},
                {name:'酒店联系人',value:'offer_name',width:100},{name:'早餐',value:'breakfastType',width:80},{name:'订金(元)',value:'deposit',width:80,first:true},{name:'总支付(元)',value:'price',width:80,first:true},{name:'总应收(元)',value:'price_pay',width:80,first:true},
                {name:'利润(元)',value:'profit',width:100},{name:'备注',value:'travel_flag_content',width:200}
            ],
            layout:[{name:'大床房(间)',id:1},{name:'双床房(间)',id:2},{name:'三床房(间)',id:3},{name:'亲子房(间)',id:3},{name:'套房(间)',id:3}],
            isGroup: false,
            tableData: [{},{},{}],
            total:0,
            page:1,
            items: [],
            searchCon: null,   //搜索条件
            order_date_in:0,   //排序
            ruleForm: {
                travel_flag_content: '',
                bg_color:'',
                oid:'',
            },
            orderType: 3,
            tabArr:[
                {label:'待打款',id:'1',value:'green'},
                {label:'已打款',id:'2',value:'green'},
                {label:'提现处理中',id:'8',value:'text-info'},
                {label:'提现未通过',id:'9',value:'red'},
            ],  
        };
    },
    components: { SearchCon},
    computed:{
        ...mapState(['TotalOrder','userLoginMessage']),
        ...mapGetters(['storeInfo']),
    },
    mounted() {
        this.PsotBusinessList();
    },
    watch: {
        //接收到消息更新列表
        newMessageInform (newVal) {
            if(newVal.type==106){
                this.PsotBusinessList(1);
            }
        },
    },
    methods: {
        ...mapActions(['businessList','businessEdit','businessWithdraw']),
        //点击操作按钮
        handleCommand(command,Itemize) {
            let htis = this;
            switch (command) {
            case '1':
                this.goHotelDetail(Itemize);
                break
            case '2':
                this.handleEdit(Itemize)
                break
            case '3':
                this.withdrawal(Itemize)
            break
            }
        },
        PsotBusinessList(v){
            let date={
                uid:this.userLoginMessage.uid,
                page:v?v:this.page,
                ...this.searchCon,
                order_date_in:this.order_date_in
            }
            this.businessList({
              data:date,
              successFun:(res) => {
                const weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
                for(let i in res.list){                    //入住时间
                    res.list[i].check_date=dayjs(res.list[i].date_in*1000 ).format('YYYY年MM月DD日');;
                    res.list[i].weekNum = weekMap[dayjs(res.list[i].date_in*1000).day()];
                    //状态
                    this.$GVAR.TOrderStatus.map(item=>{
                        if(item.id==res.list[i].status){
                            res.list[i].statusName= item.name
                        }
                    })
                    //早餐类型
                    this.$GVAR.breakfastArr.map(item=>{
                        if(item.id==res.list[i].breakfast_type){
                            res.list[i].breakfastType=item.name
                        }
                    })
                    //天数加个晚
                    res.list[i].days=res.list[i].days+'晚'
                    res.list[i].index=i;
                    //总支付跟利润/100
                    res.list[i].price_pay=res.list[i].price_pay/100;
                    res.list[i].profit=res.list[i].profit?(res.list[i].profit/100).toFixed(2):'';
                }
                let PersonnelList=[]
                for(let i in res.user_list){
                    PersonnelList.push({name:res.user_list[i].truename,id:res.user_list[i].uid})
                }
                PersonnelList.unshift({name:'全部',uid:0})
                this.PersonnelList=PersonnelList
                this.total=res.count;
                this.BusinessList=res.list;
              }
            });
        },
         //订单详情页
        goHotelDetail (e) {
            let BusinessList=this.BusinessList;
            let cardItem=BusinessList[e];
            console.log(this.storeInfo)
            let routeUrl = this.$router.resolve({
                name: 'OrderDetail',
                query: {
                    orderType: this.orderType,
                    orderId: cardItem.oid,
                    storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    status: cardItem.status,
                }
            });
            window.open(routeUrl.href, '_blank');
        },
        setRowClassName({ row, rowIndex }) {
            //根据行数据返回类名
            if (row.bg_color != '') {
                return {backgroundColor:'#'+row.bg_color}
            }
            return ''; // 默认不添加类
        },
        // 鼠标右键事件
        onContextmenu(event) {
            this.$contextmenu({
                items: this.contextMenuData,
                event, // 鼠标事件信息
                customClass: 'custom-class', // 自定义菜单 class
                zIndex: 3, // 菜单样式 z-index
                minWidth: 230 // 主菜单最小宽度
            });
            return false;
        },
        //点击编辑
        handleEdit(e){
            let BusinessList=this.BusinessList;
            this.Editindex=BusinessList[e];
            this.showEdit=true;
            this.ruleForm.travel_flag_content= this.Editindex.travel_flag_content;
            this.ruleForm.oid= this.Editindex.oid;
            this.ruleForm.bg_color= this.Editindex.bg_color?'#'+this.Editindex.bg_color:'';
            console.log(this.ruleForm);
        },
        //点击提现
        withdrawal(e){
            let BusinessList=this.BusinessList;
            let Editindex=BusinessList[e];
            let data={
                oid:Editindex.oid
                }
            console.log(Editindex.oid);
            this._confirm('申请利润提现？', async () => {
                this.businessWithdraw({
                    data,
                    successFun:(res) => {
                        this.$message.success('提交申请成功！');
                        this.PsotBusinessList();
                    }
                })
            })
        },
        /*根据条件搜索订单*/
        getSearchCon(con) {
            this.searchCon = con;
            this.page =1;
            this.PsotBusinessList();
        },
        //排序
        sortChange(e){
            this.order_date_in=e.order==='ascending'?2:e.order==='descending'?1:0;
            this.PsotBusinessList();
            console.log(e.order,this.order_date_in);
        },
        //修改订单
        editItem(){
            console.log(this.ruleForm,)
            this.businessEdit({
                data:this.ruleForm,
                successFun:(res) => {
                    this.$message.success('编辑成功！')
                    this.PsotBusinessList();
                    this.showEdit=false;
                }
            })
        },
        //团队状态颜色
        activechange(e){
            let tabArr=[
                    {title: '询价中', status: '4',value:'red'}, 
                    {title: '待入住', status: '7',value:'green'},
                    {title: '已入住', status: '8',value:'green'},
                    {title: '完成', status: '9',value:'green'}, 
                    {title: '取消',status: '99',value:'delete'}, 
                    {title: '入住中', status: 'stay',value:'green'},
                ]
                let index=tabArr.filter(item=>item.title==e);          
                return index[0].value
        },

  }
};
</script>
<style >
.demo-ruleForm{
    width: 97%;
    margin: 0 auto;
}
/* 全局样式：修改二级菜单背景色 */
.vip-row{
    background-color: #000 !important;
}
.square{
    width:100%;
    display: flex;
    justify-content: center;
}
.square span{
    padding: 0 6px;
    display: block;
}
.verify .verify_arrFlag{
    text-align: center;
    width: 24%;
    font-size: 12px;
}
.verify .verify_arrTitle{
    font-size: 12px;
    display: block;
    margin-top: 4px;
}
.background{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
}
.background_select{
    display: flex;
    width: 80%;
    justify-content: space-between;
}
.background .teilte{
    line-height: 38px;
}
.background_select .yas{
        width: 86%;
        border-radius: 4px;
        border: 1px #eee solid;
        height: 38px;
        display: block;
}
.businesslist .el-table .el-table__cell{
    padding: 4px 0;
}
.businesslist .el-table .cell,.businesslist .el-table--border .el-table__cell:first-child .cell,.businesslist .el-table th.el-table__cell > .cell{
    padding: 0;
}
.businesslist th{
    background-color: #15c0db !important;
    color: #fff;
}
.busninessList{
    margin: 0 auto;
}
.busninessList ul li{
        display: flex;
    justify-content: center;
}
.busninessList span{
    width: 50px;
    text-align: center;
    font-size: 12px;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    height: 20px;
}
.busninessList .timeslot{
    width: 70px;
    text-align:left;
}

.el-table .sort-caret.ascending{
    border-bottom-color: #fff;
}
.el-table .sort-caret.descending{
border-top-color: #fff;
}
.businesslist .ascending .sort-caret.ascending{
border-bottom-color: #fdb900;
}
.businesslist .descending .sort-caret.descending{
    border-top-color: #fdb900;
}
/* 隐藏横向滚动条 */
.businesslist .el-table__body-wrapper {
  overflow-x: scroll;
  margin-bottom: -17px; /* 隐藏滚动条的高度 */
  padding-bottom: 17px; /* 恢复被隐藏的内容区域 */
}

/* 确保表格内容不会被遮挡 */
.businesslist .el-table__body {
  margin-bottom: 0 !important;
}
.tabarr{
    font-size: 12px;
    margin-top: 6px;
    width: 100%;
    text-align: center;
    display: block;
}
.scope_button{
    display: flex;
    justify-content:left;
    width: 94%;
    margin: 0 auto;
}
</style>
